import { Link, matchPath, useLocation } from "react-router-dom";
import { useNotificationCount } from "~context/NotificationCountContext/NotificationCountContext.tsx";

export const NotificationsInfo = () => {
  const { count } = useNotificationCount();

  const location = useLocation();

  // We are out of routes definition context here, so useParams won't work.
  // Extract customer id manually from the current URL
  const match = matchPath("/:customerId/*", location.pathname);
  const customerId = match?.params?.customerId;

  return (
    <div className="notifications-info">
      {customerId && (
        <Link
          to={`/${customerId}/notifications`}
          state={{ from: location.pathname }}
          style={{ textDecoration: "none", position: "relative" }}
        >
          <div className="icon-circle">
            <i className="fa-solid fa-bell fa-lg bell-icon"></i>
          </div>
          {count > 0 && (
            <div
              style={{
                top: 10,
                right: 0,
                background: "red",
                position: "absolute",
                width: 20,
                height: 20,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 20,
              }}
              className="notificationBadge"
            >
              <div style={{ fontSize: 14, color: "#FFFFFF", fontWeight: "bold" }}>{count > 99 ? "99+" : count}</div>
            </div>
          )}
        </Link>
      )}
      {!customerId && (
        <div className="icon-circle icon-circle-blocked">
          <i className="fa-solid fa-bell fa-lg bell-icon-blocked"></i>
        </div>
      )}
    </div>
  );
};
